import React, { Component } from "react";
import DataTable from "../../components/data-table";
import * as auditlogsservice from "../../services/kyc/audit-logs-service";
import { dateFormatWithTime } from "../../utils/date";
import * as Loader from "../../common/common";
import { withRouterProps } from "../../common/hocs";

class AuditLogs extends Component {
  state = {
    headers: [
      { title: "Client", accessor: "clientName", index: 0, dataType: "string" },
      { title: "KYC Type", accessor: "kycType", index: 1, dataType: "string" },
      {
        title: "FieldName",
        accessor: "fieldName",
        index: 3,
        dataType: "string",
      },
      {
        title: "Previous Value",
        accessor: "previousValue",
        index: 4,
        dataType: "string",
      },
      {
        title: "New Value",
        accessor: "newValue",
        index: 5,
        dataType: "string",
      },
      {
        title: "Modified By",
        accessor: "modifiedBy",
        index: 6,
        dataType: "string",
      },
      {
        title: "Created At",
        accessor: "createdAt",
        index: 7,
        dataType: "string",
      },
    ],
    data: [],
    clientId: this.props.router.params.clientId,
  };
  async getAuditLogs(clientId) {
    Loader.showLoader();
    let { response, err } = await auditlogsservice.getAuditLogs(clientId);
    Loader.hideLoader();
    if (err) {
      this.setState({
        message: "Error : " + err,
        labelvalue: "Error : " + err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: "Error : " + response.data.err,
        labelvalue: "Error : " + response.data.err,
      });
    } else {
      let data = response.data ? JSON.parse(response.data) : [];
      let modifiedData =
        data &&
        data.length > 0 &&
        data.map((r) => {
          r.createdAt = dateFormatWithTime(r.createdAt);
          return r;
        });
      this.setState({
        data: modifiedData,
      });
    }
  }
  componentDidMount() {
    this.getAuditLogs(this.state.clientId);
  }
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div>&nbsp;</div>
            <div className="col-md-12">
              <h4>Audit Logs</h4>
              <div>&nbsp;</div>
              <DataTable
                className="data-table"
                keyField="id"
                pagination={{
                  enabled: true,
                  pageLength: 25,
                  type: "long",
                }}
                width="100%"
                headers={this.state.headers}
                data={this.state.data ? this.state.data : []}
                noData="No records!"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(AuditLogs);